export type TriggerActionType = 'SMS' | 'EMAIL';

export type ValueComparison = {
  resource: string;
  resourceField: string;
  operator: string;
  value: string | string[];
};

export type Condition = {
  field: string;
  operator: 'equal' | 'not equal' | 'includes' | 'not includes';
  type: 'Comparison' | 'Complete' | 'ValueComparison';
  value: string | string[];
  resource: string;
  resourceField: string;
  valueComparisons?: ValueComparison[];
};

export type Action = {
  body: string;
  fishIds: string[];
  html?: string | null;
  htmlEditorJson?: any;
  openTableTags: boolean;
  recipientType: string;
  sendDelayAmount: number;
  sendDelayUnit: string;
  /** 'HH:mm' venue time. When set, the message goes out the next time the clock reads it, instead of after the delay. */
  sendAtTimeOfDay?: string;
  senderId: string;
  /** Trigger-data key holding the FROM inbox; set only on triggers saved before attached inbox types. */
  senderField?: string;
  /** Attached inbox type (e.g. 'STYLIST') whose inbox sends the message; senderId is the fallback. */
  senderInboxType?: string;
  subject: string;
  tagsToAdd: string[];
  tagsToRemove: string[];
  type: TriggerActionType;
  userRoleIds: string[];
  userIds: string[];
  /** Trigger-data key resolved to a staff user at send time; userIds is the fallback. */
  userField?: string;
  /** Attached inbox type whose staff user receives the message; userIds is the fallback. */
  recipientInboxType?: string;
};

/** An attached inbox type a stage type's events carry, from GET /attached-inbox-types. */
export type AttachedInboxTypeOption = {
  type: string;
  label: string;
};

/** A person an activity flow event names, as returned by POST /activity's meta. */
export type AttachedInbox = {
  type: string;
  inboxId: string | null;
  userId: string | null;
};

/**
 * Trigger-data fields that saved triggers used as their sender before attached inbox
 * types, and the type each now means. The form shows such a trigger as that type.
 */
export const LEGACY_SENDER_FIELD_INBOX_TYPES: Record<string, string> = {
  attachedInboxId: 'STYLIST'
};

export type Trigger = {
  actions: Action;
  conditions: Condition;
  createdAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  flowStageId: string;
  id: string;
  title: string;
  updatedAt: string | null;
};
